import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shippingDetails: {
    id: 'LgrzPy',
    defaultMessage: 'Shipping Details',
    description: 'Header for the shipping details section in the purchase order page',
  },
  shippingCarrier: {
    id: 'GRPTqT',
    defaultMessage: 'Shipping carrier',
    description: 'Label for the shipping carrier field in the shipping details section',
  },
  trackingNumber: {
    id: 'g8CgkR',
    defaultMessage: 'Tracking number',
    description: 'Label for the tracking number field in the shipping details section',
  },
  orderId: {
    id: '9mkXYY',
    defaultMessage: 'Order ID',
    description: 'Label for the order ID field in the shipping details section',
  },
  referenceNumber: {
    id: '4osiYS',
    defaultMessage: 'Reference number',
    description: 'Label for the reference number field in the shipping details section',
  },
  orderDate: {
    defaultMessage: 'Order date',
    id: '13yUPx',
    description: 'Label for Order date',
  },
  expectedDeliveryDate: {
    defaultMessage: 'Expected delivery date',
    id: 'iFSYC8',
    description: 'Label for Expected delivery date',
  },
});
